import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';

export type DeviceReportTableData = { 
        reportData: Array<{
            deviceId: string;
            deviceName: string;
            monthAndYear: string;
            downloadUrl: string;           
        }>; 
};

type ContextState = Data<DeviceReportTableData>;
const Context = React.createContext<ContextState | null>(null);

function useReportTableListDetails(): ContextState {

    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useReportTableListDetails  details must be used within a Reprot table data');
    }

    return contextState;
};

const DeviceReportDataProvider: React.FC<{ deviceId: string; startMonthAndYear?: string; endMonthAndYear?: string}> = (props) => {

    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'report-generate',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getReportTableDataList(props.deviceId, authHelper, props.startMonthAndYear, props.endMonthAndYear), [
            props.deviceId,
            authHelper,
             props.startMonthAndYear,
             props.endMonthAndYear
        ])
    });
    
    const reportListData = dataFromDataset(dataset);   
    return <Context.Provider value={reportListData}>{props.children}</Context.Provider>;
};
const TestDeviceReportDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceReportDataProvider, TestDeviceReportDataProvider, useReportTableListDetails };
